import React from 'react';
import ScrollHint from '../ScrollHint';

function TemplateDesignSelector({
  template,
  templateType,
  teamSport,
  onTemplateChange,
}) {
  return (
    <div className="template-design-selector">
      <label>
        Template Design
        <span
          style={{
            fontSize: '12px',
            color: '#718096',
            fontWeight: 'normal',
            marginLeft: '8px',
          }}
        >
          (Choose your layout style)
        </span>
      </label>
      <div className="template-carousel-wrapper">
        <ScrollHint />
        <div className="template-carousel">

          {/* ── GAME DAY (preview) TEMPLATES ── */}
          {templateType === 'preview' && (
            <>
              <button
                type="button"
                className={`template-design-btn ${template === 'classic' ? 'active' : ''}`}
                onClick={() => onTemplateChange('classic')}
              >
                <div className="template-design-preview classic-preview">
                  <div className="preview-badge">GAME DAY</div>
                  <div className="preview-logo">
                    {teamSport === 'Softball' ? '🥎' : '⚾'}
                  </div>
                  <div className="preview-vs">VS</div>
                  <div className="preview-details">
                    <div className="preview-line"></div>
                    <div className="preview-line"></div>
                  </div>
                </div>
                <span className="template-design-name">Classic</span>
                <span className="template-design-tier">Free</span>
              </button>

              <button
                type="button"
                className={`template-design-btn ${template === 'splitScreen' ? 'active' : ''}`}
                onClick={() => onTemplateChange('splitScreen')}
              >
                <div className="template-design-preview split-preview">
                  <div className="split-left">
                    <div className="preview-logo-small">
                      {teamSport === 'Softball' ? '🥎' : '⚾'}
                    </div>
                  </div>
                  <div className="split-right">
                    <div className="preview-line"></div>
                    <div className="preview-vs-small">VS</div>
                    <div className="preview-line"></div>
                  </div>
                </div>
                <span className="template-design-name">Split Screen</span>
                <span className="template-design-tier">Free</span>
              </button>

              <button
                type="button"
                className={`template-design-btn ${template === 'bold' ? 'active' : ''}`}
                onClick={() => onTemplateChange('bold')}
              >
                <div className="template-design-preview bold-preview">
                  <div className="preview-ball-corner-left">
                    {teamSport === 'Softball' ? '🥎' : '⚾'}
                  </div>
                  <div className="preview-text-huge">TEAM</div>
                  <div className="preview-vs-bold">VS</div>
                  <div className="preview-text-huge">TEAM</div>
                </div>
                <span className="template-design-name">Bold</span>
                <span className="template-design-tier">Free</span>
              </button>

              <button
                type="button"
                className={`template-design-btn ${template === 'minimal' ? 'active' : ''}`}
                onClick={() => onTemplateChange('minimal')}
              >
                <div className="template-design-preview minimal-preview">
                  <div className="preview-ball-corner">
                    {teamSport === 'Softball' ? '🥎' : '⚾'}
                  </div>
                  <div className="preview-line-center"></div>
                  <div className="preview-vs-large">VS</div>
                  <div className="preview-line-center"></div>
                </div>
                <span className="template-design-name">Minimal</span>
                <span className="template-design-tier">Free</span>
              </button>

              <button
                type="button"
                className={`template-design-btn ${template === 'photoFrame' ? 'active' : ''}`}
                onClick={() => onTemplateChange('photoFrame')}
              >
                <div className="template-design-preview photo-frame-preview">
                  <div className="preview-photo-placeholder">📸</div>
                  <div className="preview-overlay-text">TEAM vs TEAM</div>
                </div>
                <span className="template-design-name">Photo Frame</span>
                <span className="template-design-tier">Free</span>
              </button>

              <button
                type="button"
                className={`template-design-btn ${template === 'stack' ? 'active' : ''}`}
                onClick={() => onTemplateChange('stack')}
              >
                <div
                  className="template-design-preview"
                  style={{ background: '#111827', position: 'relative', overflow: 'hidden' }}
                >
                  <div style={{ position: 'absolute', top: 0, left: 0, bottom: 0, width: 4, background: '#60a5fa' }} />
                  <div style={{ position: 'absolute', top: 6, left: 10, fontFamily: 'Bebas Neue', fontSize: 26, lineHeight: 1, color: '#ffffff' }}>GAME</div>
                  <div style={{ position: 'absolute', top: 26, left: 10, fontFamily: 'Bebas Neue', fontSize: 26, lineHeight: 1, color: '#60a5fa' }}>DAY</div>
                  <div style={{ position: 'absolute', top: 56, left: 10, width: 20, height: 2, background: '#60a5fa' }} />
                  <div style={{ position: 'absolute', top: 62, left: 10, fontFamily: 'Bebas Neue', fontSize: 10, color: 'rgba(255,255,255,0.7)' }}>YOUR TEAM</div>
                  <div style={{ position: 'absolute', top: 74, left: 10, fontFamily: 'Bebas Neue', fontSize: 9, color: 'rgba(255,255,255,0.5)' }}>VS OPPONENT</div>
                </div>
                <span className="template-design-name">Stack</span>
                <span className="template-design-tier">Free</span>
              </button>

              <button
                type="button"
                className={`template-design-btn ${template === 'rivalry' ? 'active' : ''}`}
                onClick={() => onTemplateChange('rivalry')}
              >
                <div
                  className="template-design-preview"
                  style={{ position: 'relative', overflow: 'hidden', padding: 0 }}
                >
                  <div style={{ position: 'absolute', top: 0, left: 0, width: '50%', bottom: 0, background: '#003366' }} />
                  <div style={{ position: 'absolute', top: 0, left: '50%', right: 0, bottom: 0, background: '#c8a200' }} />
                  <div style={{ position: 'absolute', top: 0, left: '46%', width: 8, bottom: 0, background: 'rgba(0,0,0,0.3)', transform: 'rotate(8deg)' }} />
                  <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <span style={{ fontFamily: 'Bebas Neue', fontSize: 28, color: '#ffffff', textShadow: '0 2px 8px rgba(0,0,0,0.8)', letterSpacing: 2 }}>VS</span>
                  </div>
                </div>
                <span className="template-design-name">Rivalry</span>
                <span className="template-design-tier">Free</span>
              </button>

              <button
                type="button"
                className={`template-design-btn ${template === 'poster' ? 'active' : ''}`}
                onClick={() => onTemplateChange('poster')}
              >
                <div
                  className="template-design-preview"
                  style={{ background: '#1a1a1a', position: 'relative', overflow: 'hidden' }}
                >
                  <div style={{ position: 'absolute', top: 0, bottom: 0, left: 0, width: 2, background: 'rgba(255,255,255,0.2)' }} />
                  <div style={{ position: 'absolute', top: 0, bottom: 0, left: '35%', right: 0, background: 'rgba(0,0,0,0.5)' }} />
                  <div style={{ position: 'absolute', top: 8, right: 8, fontFamily: 'Bebas Neue', fontSize: 9, color: '#60a5fa', letterSpacing: 2 }}>GAME DAY</div>
                  <div style={{ position: 'absolute', bottom: 28, right: 8, fontFamily: 'Bebas Neue', fontSize: 24, lineHeight: 1, color: '#ffffff' }}>GAME</div>
                  <div style={{ position: 'absolute', bottom: 10, right: 6, fontFamily: 'Bebas Neue', fontSize: 24, lineHeight: 1, color: '#60a5fa' }}>DAY</div>
                </div>
                <span className="template-design-name">Poster</span>
                <span className="template-design-tier">Free</span>
              </button>
            </>
          )}

          {/* ── GAME RECAP TEMPLATES ── */}
          {templateType === 'recap' && (
            <>
              <button
                type="button"
                className={`template-design-btn ${template === 'classic' ? 'active' : ''}`}
                onClick={() => onTemplateChange('classic')}
              >
                <div
                  className="template-design-preview"
                  style={{ background: '#1a1a2e', position: 'relative', overflow: 'hidden' }}
                >
                  <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 14, background: '#3b82f6' }} />
                  <div style={{ position: 'absolute', top: 18, left: 0, right: 0, textAlign: 'center', fontFamily: 'Bebas Neue', fontSize: 9, color: '#ffffff', letterSpacing: 2 }}>VICTORY</div>
                  <div style={{ position: 'absolute', top: 28, left: 0, width: '50%', textAlign: 'center', fontFamily: 'Bebas Neue', fontSize: 38, lineHeight: 1, color: '#ffffff' }}>7</div>
                  <div style={{ position: 'absolute', top: 28, left: '50%', width: '50%', textAlign: 'center', fontFamily: 'Bebas Neue', fontSize: 38, lineHeight: 1, color: 'rgba(255,255,255,0.4)' }}>3</div>
                  <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: 18, background: '#3b82f6' }} />
                </div>
                <span className="template-design-name">Standard</span>
                <span className="template-design-tier">Free</span>
              </button>

              <button
                type="button"
                className={`template-design-btn ${template === 'finalScore' ? 'active' : ''}`}
                onClick={() => onTemplateChange('finalScore')}
              >
                <div
                  className="template-design-preview"
                  style={{ background: '#1a1a2e', position: 'relative', overflow: 'hidden' }}
                >
                  <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 12, background: '#3b82f6' }} />
                  <div style={{ position: 'absolute', top: 0, bottom: 0, left: '50%', width: 1, background: 'rgba(255,255,255,0.2)', transform: 'translateX(-50%)' }} />
                  <div style={{ position: 'absolute', top: 16, left: '25%', transform: 'translateX(-50%)', fontFamily: 'Bebas Neue', fontSize: 50, lineHeight: 1, color: '#ffffff' }}>7</div>
                  <div style={{ position: 'absolute', top: 16, left: '75%', transform: 'translateX(-50%)', fontFamily: 'Bebas Neue', fontSize: 50, lineHeight: 1, color: 'rgba(255,255,255,0.45)' }}>3</div>
                  <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: 16, background: '#3b82f6' }} />
                </div>
                <span className="template-design-name">Final Score</span>
                <span className="template-design-tier">Free</span>
              </button>

              <button
                type="button"
                className={`template-design-btn ${template === 'victory' ? 'active' : ''}`}
                onClick={() => onTemplateChange('victory')}
              >
                <div
                  className="template-design-preview"
                  style={{ background: '#0f1923', position: 'relative', overflow: 'hidden' }}
                >
                  <div style={{ position: 'absolute', bottom: -20, right: -20, width: 70, height: 70, background: '#3b82f6', transform: 'rotate(25deg)' }} />
                  <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.1) 100%)' }} />
                  <div style={{ position: 'absolute', top: 8, left: 8, fontFamily: 'Bebas Neue', fontSize: 9, background: '#3b82f6', color: '#fff', padding: '2px 6px', letterSpacing: 1 }}>WIN</div>
                  <div style={{ position: 'absolute', bottom: 20, left: 8, fontFamily: 'Bebas Neue', fontSize: 44, lineHeight: 1, color: '#ffffff' }}>
                    7<span style={{ fontSize: 22, color: 'rgba(255,255,255,0.4)' }}>-</span><span style={{ color: 'rgba(255,255,255,0.5)' }}>3</span>
                  </div>
                </div>
                <span className="template-design-name">Victory</span>
                <span className="template-design-tier">Free</span>
              </button>

              <button
                type="button"
                className={`template-design-btn ${template === 'highlight' ? 'active' : ''}`}
                onClick={() => onTemplateChange('highlight')}
              >
                <div
                  className="template-design-preview"
                  style={{ background: '#0d0f14', position: 'relative', overflow: 'hidden' }}
                >
                  <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 14, background: '#3b82f6' }} />
                  <div style={{ position: 'absolute', top: 0, bottom: 0, left: 0, width: 3, background: '#3b82f6' }} />
                  <div style={{ position: 'absolute', top: 16, left: 8, fontFamily: 'Bebas Neue', fontSize: 22, lineHeight: 1, color: '#3b82f6', letterSpacing: 1 }}>VICTORY</div>
                  <div style={{ position: 'absolute', top: 40, left: 8, fontFamily: 'Bebas Neue', fontSize: 9, color: '#3b82f6', letterSpacing: 2 }}>PLAYER OF THE GAME</div>
                  <div style={{ position: 'absolute', top: 52, left: 8, fontFamily: 'Bebas Neue', fontSize: 18, lineHeight: 1, color: '#ffffff' }}>J. SMITH</div>
                  <div style={{ position: 'absolute', top: 72, left: 8, fontFamily: 'Bebas Neue', fontSize: 10, color: 'rgba(255,255,255,0.55)' }}>2-3, HR, 3 RBI</div>
                  <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: 12, background: 'rgba(255,255,255,0.06)' }} />
                </div>
                <span className="template-design-name">Highlight</span>
                <span className="template-design-tier">Free</span>
              </button>

              <button
                type="button"
                className={`template-design-btn ${template === 'clean' ? 'active' : ''}`}
                onClick={() => onTemplateChange('clean')}
              >
                <div
                  className="template-design-preview"
                  style={{ background: '#3b82f6', position: 'relative', overflow: 'hidden' }}
                >
                  {/* White panel — bottom half */}
                  <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: '50%', background: '#ffffff' }} />
                  {/* Home circle */}
                  <div style={{
                    position: 'absolute', top: '28%', left: '20%',
                    width: 28, height: 28, borderRadius: '50%',
                    background: '#ffffff', border: '2px solid #3b82f6',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 14, lineHeight: 1,
                  }}>⚾</div>
                  {/* Away circle */}
                  <div style={{
                    position: 'absolute', top: '28%', right: '20%',
                    width: 28, height: 28, borderRadius: '50%',
                    background: '#ffffff', border: '2px solid #3b82f6',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 14, lineHeight: 1,
                  }}>⚾</div>
                  {/* Score */}
                  <div style={{
                    position: 'absolute', bottom: 18, left: 0, right: 0,
                    textAlign: 'center', fontFamily: 'Bebas Neue', fontSize: 28,
                    color: '#3b82f6', lineHeight: 1,
                  }}>7 - 3</div>
                </div>
                <span className="template-design-name">Clean</span>
                <span className="template-design-tier">Free</span>
              </button>
            </>
          )}

          {/* ── TRYOUT TEMPLATES ── */}
          {templateType === 'tryout' && (
            <>
              <button
                type="button"
                className={`template-design-btn ${template === 'poster' ? 'active' : ''}`}
                onClick={() => onTemplateChange('poster')}
              >
                <div
                  className="template-design-preview"
                  style={{ background: '#1a1a2e', position: 'relative', overflow: 'hidden' }}
                >
                  <div style={{ position: 'absolute', top: 8, left: 8, fontFamily: 'Bebas Neue', fontSize: 28, color: '#ffffff', letterSpacing: 2, lineHeight: 1 }}>TRYOUTS</div>
                  <div style={{ position: 'absolute', top: 38, left: 8, fontFamily: 'Bebas Neue', fontSize: 14, color: 'rgba(255,255,255,0.6)', letterSpacing: 1 }}>TEAM NAME</div>
                  <div style={{ position: 'absolute', bottom: 12, left: 8, right: 8, display: 'flex', flexDirection: 'column', gap: 4 }}>
                    <div style={{ height: 4, background: '#3b82f6', borderRadius: 2 }} />
                    <div style={{ height: 4, background: 'rgba(255,255,255,0.3)', borderRadius: 2, width: '70%' }} />
                    <div style={{ height: 4, background: 'rgba(255,255,255,0.3)', borderRadius: 2, width: '50%' }} />
                  </div>
                </div>
                <span className="template-design-name">Poster</span>
                <span className="template-design-tier">Free</span>
              </button>

              <button
                type="button"
                className={`template-design-btn ${template === 'infoCard' ? 'active' : ''}`}
                onClick={() => onTemplateChange('infoCard')}
              >
                <div
                  className="template-design-preview"
                  style={{ background: '#3b82f6', position: 'relative', overflow: 'hidden' }}
                >
                  <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '45%', display: 'flex', alignItems: 'center', paddingLeft: 8 }}>
                    <span style={{ fontFamily: 'Bebas Neue', fontSize: 20, color: '#ffffff', letterSpacing: 2 }}>TRYOUTS</span>
                  </div>
                  <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: '55%', background: '#ffffff', padding: '4px 8px', display: 'flex', flexDirection: 'column', gap: 3 }}>
                    <div style={{ height: 4, background: '#3b82f6', borderRadius: 2, width: '80%' }} />
                    <div style={{ height: 4, background: '#e2e8f0', borderRadius: 2 }} />
                    <div style={{ height: 4, background: '#e2e8f0', borderRadius: 2, width: '60%' }} />
                  </div>
                </div>
                <span className="template-design-name">Info Card</span>
                <span className="template-design-tier">Free</span>
              </button>

              {false && (
              <button
                type="button"
                className={`template-design-btn ${template === 'classic' ? 'active' : ''}`}
                onClick={() => onTemplateChange('classic')}
              >
                <div className="template-design-preview classic-preview">
                  <div className="preview-badge">TRYOUTS</div>
                  <div className="preview-logo">
                    {teamSport === 'Softball' ? '🥎' : '⚾'}
                  </div>
                  <div className="preview-details">
                    <div className="preview-line"></div>
                    <div className="preview-line"></div>
                  </div>
                </div>
                <span className="template-design-name">Classic</span>
                <span className="template-design-tier">Free</span>
              </button>
              )}

              <button
                type="button"
                className={`template-design-btn ${template === 'splitScreen' ? 'active' : ''}`}
                onClick={() => onTemplateChange('splitScreen')}
              >
                <div className="template-design-preview split-preview">
                  <div className="split-left">
                    <div className="preview-logo-small">
                      {teamSport === 'Softball' ? '🥎' : '⚾'}
                    </div>
                  </div>
                  <div className="split-right">
                    <div className="preview-line"></div>
                    <div className="preview-line"></div>
                  </div>
                </div>
                <span className="template-design-name">Split Screen</span>
                <span className="template-design-tier">Free</span>
              </button>

              {false && (
              <button
                type="button"
                className={`template-design-btn ${template === 'bold' ? 'active' : ''}`}
                onClick={() => onTemplateChange('bold')}
              >
                <div className="template-design-preview bold-preview">
                  <div className="preview-ball-corner-left">
                    {teamSport === 'Softball' ? '🥎' : '⚾'}
                  </div>
                  <div className="preview-text-huge">TRYOUT</div>
                </div>
                <span className="template-design-name">Bold</span>
                <span className="template-design-tier">Free</span>
              </button>
              )}

              {false && (
              <button
                type="button"
                className={`template-design-btn ${template === 'minimal' ? 'active' : ''}`}
                onClick={() => onTemplateChange('minimal')}
              >
                <div className="template-design-preview minimal-preview">
                  <div className="preview-ball-corner">
                    {teamSport === 'Softball' ? '🥎' : '⚾'}
                  </div>
                  <div className="preview-line-center"></div>
                </div>
                <span className="template-design-name">Minimal</span>
                <span className="template-design-tier">Free</span>
              </button>
              )}

              {false && (
              <button
                type="button"
                className={`template-design-btn ${template === 'photoFrame' ? 'active' : ''}`}
                onClick={() => onTemplateChange('photoFrame')}
              >
                <div className="template-design-preview photo-frame-preview">
                  <div className="preview-photo-placeholder">📸</div>
                  <div className="preview-overlay-text">TRYOUTS</div>
                </div>
                <span className="template-design-name">Photo Frame</span>
                <span className="template-design-tier">Free</span>
              </button>
              )}

            </>
          )}

          {/* ── PLAYER SPOTLIGHT TEMPLATES ── */}
          {templateType === 'highlight' && (
            <>
              <button
                type="button"
                className={`template-design-btn ${template === 'showcase' ? 'active' : ''}`}
                onClick={() => onTemplateChange('showcase')}
              >
                <div className="template-design-preview" style={{
                  background: 'linear-gradient(160deg, #1a1a2e 60%, #e63946 100%)',
                  position: 'relative',
                  overflow: 'hidden',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                  padding: '6px',
                }}>
                  <div style={{
                    position: 'absolute', top: 0, left: 0,
                    width: '4px', height: '100%',
                    background: '#e63946',
                  }} />
                  <div style={{
                    background: 'rgba(255,255,255,0.15)',
                    borderRadius: '20px',
                    padding: '2px 6px',
                    fontSize: '5px',
                    color: 'white',
                    letterSpacing: '1px',
                    marginBottom: '4px',
                  }}>PLAYER SPOTLIGHT</div>
                  <div style={{
                    width: '100%',
                    background: '#e63946',
                    padding: '3px 0',
                    textAlign: 'center',
                    fontSize: '7px',
                    fontWeight: 900,
                    color: 'white',
                    letterSpacing: '1px',
                  }}>PLAYER NAME</div>
                  <div style={{
                    width: '100%',
                    background: 'rgba(0,0,0,0.75)',
                    padding: '2px 0',
                    textAlign: 'center',
                    fontSize: '5px',
                    color: 'rgba(255,255,255,0.8)',
                  }}>Stats · Achievements</div>
                </div>
                <span className="template-design-name">Showcase</span>
                <span className="template-design-tier">Free</span>
              </button>

              <button
                type="button"
                className={`template-design-btn ${template === 'feature' ? 'active' : ''}`}
                onClick={() => onTemplateChange('feature')}
              >
                <div className="template-design-preview" style={{
                  background: 'linear-gradient(135deg, #0f2027 0%, #203a43 100%)',
                  position: 'relative',
                  overflow: 'hidden',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-end',
                  justifyContent: 'space-between',
                  padding: '6px 6px 6px 12px',
                }}>
                  <div style={{
                    position: 'absolute', top: 0, left: 0,
                    width: '5px', height: '100%',
                    background: '#f4a261',
                  }} />
                  <div style={{
                    textAlign: 'right',
                  }}>
                    <div style={{
                      background: '#f4a261',
                      padding: '1px 4px',
                      fontSize: '4px',
                      color: 'white',
                      fontWeight: 700,
                      letterSpacing: '1px',
                      marginBottom: '2px',
                      display: 'inline-block',
                    }}>SPOTLIGHT</div>
                    <div style={{
                      fontSize: '9px',
                      fontWeight: 900,
                      color: 'white',
                      lineHeight: 1.1,
                      textAlign: 'right',
                    }}>PLAYER<br/>NAME</div>
                  </div>
                  <div style={{ width: '100%', textAlign: 'right' }}>
                    <div style={{
                      fontSize: '5px', color: 'rgba(255,255,255,0.7)',
                      borderBottom: '1px solid rgba(255,255,255,0.2)',
                      paddingBottom: '1px', marginBottom: '1px',
                    }}>Stat Line 1</div>
                    <div style={{
                      fontSize: '5px', color: 'rgba(255,255,255,0.7)',
                    }}>Stat Line 2</div>
                  </div>
                </div>
                <span className="template-design-name">Feature</span>
                <span className="template-design-tier">Free</span>
              </button>

              <button
                type="button"
                className={`template-design-btn ${template === 'card' ? 'active' : ''}`}
                onClick={() => onTemplateChange('card')}
              >
                <div className="template-design-preview" style={{
                  background: '#1a1a2e',
                  position: 'relative',
                  overflow: 'hidden',
                  display: 'flex',
                  flexDirection: 'column',
                  padding: 0,
                }}>
                  <div style={{
                    flex: '0 0 50%',
                    background: 'linear-gradient(135deg, #2d3561 0%, #1a1a2e 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '16px',
                  }}>👤</div>
                  <div style={{
                    position: 'absolute',
                    top: '50%', left: 0, right: 0,
                    height: '3px',
                    background: '#e63946',
                  }} />
                  <div style={{
                    flex: '0 0 50%',
                    background: '#e63946',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2px',
                  }}>
                    <div style={{
                      fontSize: '7px', fontWeight: 900,
                      color: 'white', letterSpacing: '1px',
                    }}>PLAYER NAME</div>
                    <div style={{
                      fontSize: '4px', color: 'rgba(255,255,255,0.8)',
                      marginTop: '1px',
                    }}>Stats · Achievements</div>
                  </div>
                </div>
                <span className="template-design-name">Card</span>
                <span className="template-design-tier">Free</span>
              </button>
            </>
          )}

        </div>
      </div>
    </div>
  );
}

export default TemplateDesignSelector;
